// =============================================
// MAIN — Entry point (modules already loaded above)
// =============================================

// All modules (cursor, nav, scroll-reveal, forms) are concatenated
// by Gulp in the correct order. This file can hold any global init.

(function () {
  // Mark body as JS-ready
  document.documentElement.classList.add('js');

  // iOS Safari :active fix — the browser only fires :active on divs
  // that have a touchstart listener (even empty). This one-liner covers
  // all interactive cards and steps without changing any HTML.
  if ('ontouchstart' in window) {
    document.querySelectorAll('.pcard, .istat, .team-card, .tstep, .feat-card').forEach(function (el) {
      el.addEventListener('touchstart', function () {}, { passive: true });
    });
  }
})();
